import Header from '../Header/Header'
import React, { useEffect, useState, useRef } from 'react'
import './index.css';
import { useDispatch, useSelector } from 'react-redux';
import userDetails from '../rtk-apis/user/userDetails';
import { AppDispatch, RootState } from '../store/store';
import { useNavigate, useLocation } from 'react-router-dom';
import { Loader, ICONS } from '@ohif/ui';
import { customStyle, formatDate, formatDays, formatTime } from '@custom/Utils/utils';
import { UserData } from '@custom/Utils/constants/interfaces';
import { useTheme } from "../../ui/src/contextProviders"

const TeleUserDetails = () => {
    const navigate = useNavigate();
    const [userData, setUserData] = useState<UserData>({} as UserData);
    const [image, setImage] = useState('');
    const fileInputRef = useRef(null);

    const dispatch = useDispatch<AppDispatch>();
    const data = useSelector((state: RootState) => state?.getUserDetails);
    const loading = useSelector((state: RootState) => state.getUserDetails.loading); // Select loading state
    const error = useSelector((state: RootState) => state.getUserDetails.error); // Select error state
    const [isLoading, setIsLoading] = useState(false);
    const [profilePic, setProfilePic] = useState<string | null>(null);

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImage(reader.result as string);
            };
            reader.readAsDataURL(file);
        }
    };

    useEffect(() => {
        const fetchUserDetails = async () => {
            try {
                setIsLoading(true);
                const result = await dispatch(userDetails()).unwrap();
                setProfilePic(result?.result?.profilePic);
            } catch (error) {
                console.error('Error fetching user details:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchUserDetails();
    }, [dispatch]);

    useEffect(() => {
        if (data?.result != null && Object.keys(data.result).length > 0) {
            setUserData(data?.result);
        }
    }, [data])

    const handleEdit = () => {
        navigate('/userProfile', { state: { userDetail: userData } })
    }

    const isDarkMode = useTheme();
    return (
        <>
            <div className='page page__full' style={
                isDarkMode?.isDarkMode ? { background: '#090c29' } : customStyle.mainBackground
            }>
                <Header title="My Profile" isBack={false}></Header>
                <div className='page__body'>
                    <div className='details'>
                        <div className='form form--innersec'>
                            <section className='form__section'>
                                <h1 className='form__section__title'> Teleradiologist User Details
                                    <button className="btn btn__primary" onClick={handleEdit}>
                                        <img src={ICONS["edit"]} alt="edit" style={{ filter: "brightness(0) invert(1)" }} className="mr-2" />
                                        Edit
                                    </button></h1>
                                <div className="formRow">
                                    <div className="formCol">
                                        <div className="form__Field">
                                            <label className="form__uploadProfileDisabled" htmlFor="uploadProfile">
                                                {profilePic && <img className="form__uploadProfileDisabled__picture" src={profilePic} alt="" />}
                                                <img className="form__uploadProfileDisabled__picture" src={ICONS.defaultUserIcon} alt="" />
                                                <span className="form__uploadProfileDisabled__overlay">
                                                    <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M15.4782 12.1589C15.4782 12.5125 15.3377 12.8516 15.0877 13.1017C14.8376 13.3517 14.4985 13.4922 14.1449 13.4922H2.14486C1.79124 13.4922 1.4521 13.3517 1.20205 13.1017C0.951999 12.8516 0.811523 12.5125 0.811523 12.1589V4.82552C0.811523 4.4719 0.951999 4.13276 1.20205 3.88271C1.4521 3.63266 1.79124 3.49219 2.14486 3.49219H4.81152L6.14486 1.49219H10.1449L11.4782 3.49219H14.1449C14.4985 3.49219 14.8376 3.63266 15.0877 3.88271C15.3377 4.13276 15.4782 4.4719 15.4782 4.82552V12.1589Z" stroke="white" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"></path>
                                                        <path d="M8.14486 10.8255C9.61762 10.8255 10.8115 9.63161 10.8115 8.15885C10.8115 6.68609 9.61762 5.49219 8.14486 5.49219C6.6721 5.49219 5.47819 6.68609 5.47819 8.15885C5.47819 9.63161 6.6721 10.8255 8.14486 10.8255Z" stroke="white" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"></path>
                                                    </svg>
                                                </span>
                                            </label>
                                            {/* <input type="file" id="uploadProfile" className="form__uploadProfileDisabled" ref={fileInputRef} disabled
                                                onChange={handleImageChange} /> */}
                                        </div>
                                    </div>
                                </div>
                                <h1 className='form__section__title'>{userData?.name}</h1>
                                <div className='formRow formRow__2'>
                                    <div className='formCol'>
                                        <strong>Phone Number:</strong>{' ' + userData?.contactNumberCountryCode} {userData?.contactNumber}
                                        <br />
                                        <strong>Email ID:</strong>{' ' + userData?.email}
                                    </div>
                                </div>
                            </section>
                            <section className='form__section'>
                                <h1 className='form__section__title'> More Information</h1>
                                <div className='formRow formRow__2'>
                                    <div className='formCol'>
                                        <div className="form__Field">
                                            <label className="form__label" htmlFor='name'>
                                                Radiologist Type
                                            </label>
                                            <span>
                                                {userData?.radiologistType ? userData?.radiologistType : "-"}
                                            </span>
                                        </div>
                                    </div>
                                    <div className='formCol'>
                                        <div className="form__Field">
                                            <label className="form__label" htmlFor='name'>
                                                User Role
                                            </label>
                                            <span>
                                                {userData?.role ? userData?.role : "-"}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className='formRow formRow__2'>
                                    <div className='formCol'>
                                        <div className="form__Field">
                                            <label className="form__label" htmlFor='name'>
                                                Name
                                            </label>
                                            <span>
                                                {userData?.name ? userData?.name : "-"}
                                            </span>
                                        </div>
                                    </div>
                                    <div className='formCol'>
                                        <div className="form__Field">
                                            <label className="form__label" htmlFor='name'>
                                                Gender
                                            </label>
                                            <span>
                                                {userData?.gender ? userData?.gender : "-"}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className='formRow formRow__2'>
                                    <div className='formCol'>
                                        <div className="form__Field">
                                            <label className="form__label" htmlFor='name'>
                                                HPR ID
                                            </label>
                                            <span>
                                                {userData?.hprId ? userData?.hprId : "-"}
                                            </span>
                                        </div>
                                    </div>
                                    <div className='formCol'>
                                        <div className="form__Field">
                                            <label className="form__label" htmlFor='name'>
                                                Email ID
                                            </label>
                                            <span>
                                                {userData?.email ? userData?.email : "-"}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className='formRow formRow__2'>
                                    <div className='formCol'>
                                        <div className="form__Field">
                                            <label className="form__label" htmlFor='name'>
                                                Contact Number
                                            </label>
                                            <span>
                                                {userData?.contactNumber ? userData?.contactNumberCountryCode + ' ' + userData?.contactNumber : "-"}
                                            </span>
                                        </div>
                                    </div>
                                    <div className='formCol'>
                                        <div className="form__Field">
                                            <label className="form__label" htmlFor='name'>
                                                Date of Birth
                                            </label>
                                            <span>
                                                {userData?.dob ? formatDate(userData?.dob) : "-"}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className='formRow formRow__2'>
                                    <div className='formCol'>
                                        <div className="form__Field">
                                            <label className="form__label" htmlFor='name'>
                                                Department
                                            </label>
                                            <span>
                                                {userData?.department ? userData?.department : "-"}
                                            </span>
                                        </div>
                                    </div>
                                    <div className='formCol'>
                                        <div className="form__Field">
                                            <label className="form__label" htmlFor='name'>
                                                Modality
                                            </label>
                                            <span>
                                                {Array.isArray(userData?.modality)
                                                    ? userData.modality.join(', ')
                                                    : userData?.modality || "-"}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className='formRow formRow__2'>
                                    <div className='formCol'>
                                        <div className="form__Field">
                                            <label className="form__label" htmlFor='name'>
                                                Study Region
                                            </label>
                                            <span>
                                                {Array.isArray(userData?.studyRegion)
                                                    ? userData.studyRegion.join(', ')
                                                    : userData?.studyRegion || "-"}
                                            </span>
                                        </div>
                                    </div>
                                    <div className='formCol'>
                                        <div className="form__Field">
                                            <label className="form__label" htmlFor='name'>
                                                Years of Experience
                                            </label>
                                            <span>
                                                {userData?.yearsOfExperience ? userData?.yearsOfExperience : "-"}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className='formRow formRow__2'>
                                    <div className='formCol'>
                                        <div className="form__Field">
                                            <label className="form__label" htmlFor='name'>
                                                Whatsapp Number
                                            </label>
                                            <span>
                                                {userData?.whatsappNumber ? userData.whatsappCountryCode + ' ' + userData?.whatsappNumber : "-"}
                                            </span>
                                        </div>
                                    </div>
                                    <div className='formCol'>
                                        <div className="form__Field">
                                            <label className="form__label" htmlFor='name'>
                                                State Medical Council Registration License Number
                                            </label>
                                            <span>
                                                {userData?.licenseNumber ? userData?.licenseNumber : "-"}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className='formRow formRow__2'>
                                    <div className='formCol'>
                                        <div className="form__Field">
                                            <label className="form__label" htmlFor='name'>
                                                Availability (Days)
                                            </label>
                                            <span>
                                                {Array.isArray(userData?.availabilityDay) && userData?.availabilityDay.length > 0
                                                    ? formatDays([...userData?.availabilityDay])
                                                    : "-"}
                                            </span>
                                        </div>
                                    </div>
                                    <div className='formCol'>
                                        <div className="form__Field">
                                            <label className="form__label" htmlFor='name'>
                                                From Timing
                                            </label>
                                            <span>
                                                {userData?.fromTimeAvailability ? formatTime(userData?.fromTimeAvailability, true) : "-"}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className='formRow formRow__2'>
                                    <div className='formCol'>
                                        <div className="form__Field">
                                            <label className="form__label" htmlFor='name'>
                                                To Timing
                                            </label>
                                            <span>
                                                {userData?.toTimeAvailability ? formatTime(userData?.toTimeAvailability, true) : "-"}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
            <Loader
                isLoaderOpen={isLoading}
                title={"Loading"}
            />
        </>
    )
}

export default TeleUserDetails
